import { SourceType } from "@/app/core/utils/enumDisplayRender";

export enum SearchOrdersSort {
  PostedAsc = "id",
  PostedDesc = "-id",
  PriceAsc = "price",
  PriceDesc = "-price",
  MoveDateAsc = "move_date",
  MoveDateDesc = "-move_date",
}
export const SearchOrdersSortDisplay: SourceType[] = [
  {
    value: SearchOrdersSort.PostedDesc,
    name: "Posted date: Latest first",
  },
  {
    value: SearchOrdersSort.PostedAsc,
    name: "Posted date: Earliest first",
  },
  {
    value: SearchOrdersSort.PriceAsc,
    name: "Price: Lowest to highest",
  },
  {
    value: SearchOrdersSort.PriceDesc,
    name: "Price: Highest to lowest",
  },
  {
    value: SearchOrdersSort.MoveDateAsc,
    name: "Move date: Nearest first",
  },
  {
    value: SearchOrdersSort.MoveDateDesc,
    name: "Move date: Farthest first",
  },
];